import type { IExistContact } from "@api";
import { Alert, Typography } from "@mui/material";
import { ContactInfo } from "./contactInfo";
import { contactInfo } from "./logics";
import { ContactInfoTooltip, EnterpriseLink } from "./styles";

interface IContactCardCreateErrorsProps {
  existsContact: IExistContact;
  existsInEnterprise: boolean;
}

export const ContactCardCreateErrors = ({ existsContact, existsInEnterprise }: IContactCardCreateErrorsProps) => {
  if (existsContact?.contact) {
    const contactName = contactInfo(existsContact.contact);
    return (
      <Alert severity="error" sx={{ my: 1 }}>
        <Typography
          component="p"
          variant="caption"
          sx={{
            color: "secondary.dark",
          }}
        >
          Le contact “
          <ContactInfoTooltip title={<ContactInfo contact={existsContact.contact} />}>
            <Typography component="span">{contactName}</Typography>
          </ContactInfoTooltip>
          ” avec le même email et numéro de téléphone existe déjà
          {existsContact.enterpriseId !== undefined ? (
            <>
              {existsInEnterprise ? (
                " dans cette page entreprise"
              ) : (
                <Typography variant="body1" component={"span"}>
                  {" "}
                  dans une autre{" "}
                  <EnterpriseLink target="_blank" to={`${"/v2/enterprise"}/${existsContact.enterpriseId}`}>
                    page entreprise.
                  </EnterpriseLink>
                </Typography>
              )}{" "}
            </>
          ) : (
            ". "
          )}
        </Typography>
      </Alert>
    );
  } else {
    return null;
  }
};
